import { __rest } from "tslib";
import React, { useRef, useState, useEffect } from 'react';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import { apiHolder as api } from 'api';
import classnames from 'classnames';
import style from './editor.module.scss';
const defaultLineHeights = [
    { name: '0', value: 0 },
    { name: '1.0', value: 1 },
    { name: '1.25', value: 1.15 },
    { name: '1.5', value: 1.5 },
    { name: '1.75', value: 1.75 },
    { name: '2.0', value: 2.0 },
    { name: '2.5', value: 2.5 },
    { name: '3.0', value: 3.0 },
];
const storeApi = api.api.getDataStoreApi();
const HOCLineHeight = (Component) => {
    const EdLineHeight = (props) => {
        const { ref, onEditCreated } = props, rest = __rest(props, ["ref", "onEditCreated"]);
        const [editorInstance, seteditorInstance] = useState(null);
        const [visible, setVisible] = useState(false);
        const [selectLineHeight, setSelectLineHeight] = useState('');
        const [defaultLineHeight, setDefaultLineHeight] = useState(1.5);
        const [tipPos, setTipPos] = useState({
            top: 0,
            left: 0,
        });
        const setVisibleRef = useRef(setVisible);
        const setTipPosRef = useRef(setTipPos);
        setVisibleRef.current = setVisible;
        setTipPosRef.current = setTipPos;
        const lineheightAction = button => {
            let elem = document.querySelector('.tox-tbtn--lx-lineheight-btn');
            while (elem) {
                if (elem.className.includes('tox-toolbar__group')) {
                    break;
                }
                elem = elem.parentElement;
            }
            const elemRect = elem.getBoundingClientRect();
            setVisibleRef.current(true);
            setTipPosRef.current({
                top: elemRect.top + 40,
                left: elemRect.left,
            });
        };
        const editorSetup = ed => {
            seteditorInstance(ed);
            onEditCreated(ed);
        };
        useEffect(() => {
            if (visible && editorInstance) {
                const lineHeight = editorInstance.queryCommandValue('LineHeight');
                setSelectLineHeight(+lineHeight);
            }
        }, [visible]);
        useEffect(() => {
            setDefaultLineHeight(storeApi.getSync('defaultLineHeight').data || 1.5);
        }, []);
        const setDefaultLineHeightCl = () => {
            if (defaultLineHeights.every(i => i.value !== selectLineHeight))
                return;
            storeApi.put('defaultLineHeight', selectLineHeight);
            setDefaultLineHeight(selectLineHeight);
        };
        const selectLineHeightCl = lineHeight => {
            const value = lineHeight.value;
            if (!editorInstance)
                return;
            setSelectLineHeight(value);
            editorInstance.execCommand('LineHeight', false, value);
            setVisible(false);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, lineheightAction: lineheightAction, onEditCreated: editorSetup })),
            React.createElement(LxPopover, { top: tipPos.top, left: tipPos.left, resetStyle: { zIndex: 999 }, visible: visible, setVisible: setVisible, acceptTopBottom: true },
                React.createElement("div", { className: classnames(style.lineHeightBoxWrap, style.fontCommaBoxWrap) },
                    React.createElement("div", { className: classnames(style.lineHeightBox) }, defaultLineHeights.map(font => (React.createElement("div", { className: classnames([style.lineHeightItem, font.value === selectLineHeight && style.fontCommaSelected]), style: { lineHeight: font.value }, onClick: () => {
                            selectLineHeightCl(font);
                        } },
                        font.name,
                        font.value === +defaultLineHeight && React.createElement("span", { className: style.fontDefault }, "\u9ED8\u8BA4"))))),
                    React.createElement("div", { className: classnames(style.setDefaultCol, defaultLineHeights.every(i => i.value !== selectLineHeight) && 'disabled'), onClick: setDefaultLineHeightCl }, "\u5C06\u5F53\u524D\u884C\u95F4\u8DDD\u8BBE\u4E3A\u9ED8\u8BA4")))));
    };
    return React.forwardRef((props, ref) => React.createElement(EdLineHeight, Object.assign({}, props, { ref: ref })));
};
export default HOCLineHeight;
